import ProgramDetailFields from '@/components/program/ProgramDetailFields';
import RuleItem from '@/components/program/RuleItem';
import { CREATE_PROGRAM_FORM } from '@/constants/forms';
import IdGeneratorService from '@/services/id-generator.service';
import { type ReactNode, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { MdPeople } from 'react-icons/md';
import SelectCopyOrNew from './SelectCopyOrNew';
import PeopleItem from './PeopleItem';
import SelectProgram from './SelectProgram';

interface Group {
	name: string;
	description: string;
	peopleCount: number;
}

type Rule = {
	icon: ReactNode;
	title: string;
	value: string;
	onClick: () => void;
};

type Program = {
	icon: ReactNode;
	title: string;
	value: string;
	description: string;
};

type Props = {
	activeIndex: number;
	rules: Rule[];
	groups: Group[];
};

const AddProgramForm = (props: Props) => {
	const { activeIndex, rules, groups } = props;
	const [addType, setAddType] = useState<string>('');
	const [selectedProgram, setSelectedProgram] = useState<string>('');

	const formName = new IdGeneratorService(CREATE_PROGRAM_FORM).formId;

	const { control } = useFormContext();

	const handleChangeType = (value: string) => {
		setAddType(value);
	};

	const handleChangeProgram = (value: string) => {
		setSelectedProgram(value);
	};

	const programs: Program[] = [
		{
			icon: '/images/svg/blue-car.svg',
			value: 'travel',
			title: 'Travel Program',
			description: `Simplify the process for employees to expense rides
			directly through the Xpress app. Additionally, gain
			valuable insights into your team's transportation
			expenditure.`,
		},
		{
			icon: '/images/svg/blue-car.svg',
			value: 'business',
			title: 'Business Travel',
			description: `Lorem ipsum dolor sit amet, consectetur adipiscing
			elit, sed do eiusmod tempor incididunt ut labore et
			dolore magna aliqua.`,
		},
	];

	const programDetails = (
		<ProgramDetailFields control={control} formName={formName} />
	);

	const customize = (
		<div className="space-y-4 mb-5">
			<div className="">
				<h2 className="text-xl text-gray-800 mb-5">Rules</h2>
				<div className="border-t border-gray-200">
					{rules.map((rule) => (
						<RuleItem
							key={rule.value}
							icon={rule.icon}
							title={rule.title}
							value={rule.value}
							onClick={rule.onClick}
						/>
					))}
				</div>
			</div>
			<div className="">
				<h2 className="text-xl text-gray-800 mb-5">People</h2>
				<div className="border-t border-gray-200">
					{groups.map((group) => (
						<PeopleItem
							key={group.name}
							icon={<MdPeople size={24} />}
							name={group.name}
							count={group.peopleCount}
							groups={groups}
						/>
					))}
				</div>
			</div>
		</div>
	);

	/* TODO: Proper Implementation
	*/
	return (
		<div>
			{activeIndex === 0 && (<SelectCopyOrNew type={addType} handleChange={handleChangeType} />)}

			{activeIndex === 1 && (
				<SelectProgram
					programs={programs}
					program={selectedProgram}
					handleChange={handleChangeProgram}
				/>
			)}

			{activeIndex === 2 && programDetails}

			{activeIndex === 3 && customize}
		</div>
	);
};

export default AddProgramForm;
